import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { DataService } from '../../services/DataService';
import Swal from 'sweetalert2';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-job-profile-landing',
    templateUrl: './job-profile-landing.component.html',
    styleUrls: ['./job-profile-landing.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JobProfileLandingComponent implements OnInit {
  
  
  constructor(private app: AppComponent,private api:DataService,private authService: MsalService,) {
    
   }
   auth_token =""
   ShowLoader :string = "none";
   username: any = ''
   menudata="FALSE";
   isButtonDisabled: boolean = false;

  ngOnInit(): void {

    this.username =this.authService.instance.getAllAccounts()[0].name;
    
    var formData: any = new FormData();
  
		formData.append("auth_token", this.auth_token);
   
		formData.append("username", this.username);

    this.api.getaccesslevel_jobprofile(this.auth_token,formData).subscribe(
			// this.api.GetDataForWordcloud(auth_token, this.form.get('SelTopWords')?.value, this.form.get('SelWordFrequency')?.value, this.form.get('SelNgrams')?.value, this.form.get('SelTextAnalysis')?.value, "", formData, this.username).subscribe(
			 //this.api.GetDataForWordcloud(auth_token, this.SelTopWords, this.SelWordFrequency, this.SelNgrams, this.SelTextAnalysis, "", this.uploadedFileName, this.username).subscribe(
			  (result: any) => {
          console.log(result.output)
          //result = JSON.parse(result);
          this.menudata = result.output;
        
          if(this.menudata=="TRUE")
            {
            this.isButtonDisabled=false
           // this.ShowLoader='none';
            }
            else
            {
              this.isButtonDisabled = true
             // this.ShowLoader='none';
            }
            
			  }
        
		)

    
  }
  new_showComponent(ncomp:any,btn:string){
    console.log('compo '+ this.isButtonDisabled)
     if(this.isButtonDisabled == true && btn == 'pro') 
       Swal.fire('Permission Denied',' For more detail contact <a href="mailto:HR_JobProfileMatching_Support@accenture.com" title="title" >HR_JobProfileMatching_Support@accenture.com</a>  ', 'info')
     else
     this.app.ShowDiv(ncomp);
    
     
   }
}
